import TableCells from 'components/TableCells';
import { CellProps, Column } from 'react-table';

import { formatNumber } from 'utils/number';

import { ParsedAdvertisersEpisodeStatsData } from '../types';

export const defaultSort = [{ id: 'episodeName', desc: false }];

const columns: ReadonlyArray<Column<ParsedAdvertisersEpisodeStatsData>> = [
  {
    Cell: TableCells.TextWithTooltipCell,
    Header: <TableCells.HeaderCell accessor="episodeName" multiline />,
    accessor: 'episodeName',
    sortType: 'string',
    width: 300,
  },
  {
    Cell: TableCells.NumericCell,
    Header: <TableCells.HeaderCell accessor="unitLoad" multiline />,
    accessor: 'unitLoad',
    sortType: 'number',
  },
  {
    Cell: TableCells.NumericCell,
    Header: <TableCells.HeaderCell accessor="unitInViewport" multiline />,
    accessor: 'unitInViewport',
    sortType: 'number',
  },
  {
    Cell: TableCells.NumericCell,
    Header: <TableCells.HeaderCell accessor="adPlayed" multiline />,
    accessor: 'adPlayed',
    sortType: 'number',
    width: 120,
  },
  {
    Cell: TableCells.NumericCell,
    Header: <TableCells.HeaderCell accessor="adClickThrough" multiline />,
    accessor: 'adClickThrough',
    sortType: 'number',
    width: 120,
  },
  {
    Cell: ({
      value,
    }: CellProps<
      ParsedAdvertisersEpisodeStatsData,
      ParsedAdvertisersEpisodeStatsData['spEngagedRate']
    >) => (
      <TableCells.NumericCell
        type="percent"
        value={formatNumber(value * 100, 2)}
      />
    ),
    Header: <TableCells.HeaderCell accessor="spEngagedInViewport" multiline />,
    accessor: 'spEngagedRate',
    sortType: 'number',
  },
  {
    Cell: TableCells.NumericCell,
    Header: <TableCells.HeaderCell accessor="spEngaged" multiline />,
    accessor: 'spEngaged',
    sortType: 'number',
  },
  {
    Cell: ({
      value,
    }: CellProps<
      ParsedAdvertisersEpisodeStatsData,
      ParsedAdvertisersEpisodeStatsData['avgCpc']
    >) => <TableCells.NumericCell type="mili-cents" value={value} />,
    Header: <TableCells.HeaderCell accessor="avgCpc" multiline />,
    accessor: 'avgCpc',
    sortType: 'number',
    width: 120,
  },
  {
    Cell: ({
      value,
    }: CellProps<
      ParsedAdvertisersEpisodeStatsData,
      ParsedAdvertisersEpisodeStatsData['total']
    >) => <TableCells.NumericCell type="mili-cents" value={value} />,
    Header: <TableCells.HeaderCell accessor="total" multiline />,
    accessor: 'total',
    sortType: 'number',
    width: 120,
  },
];

export default columns;
